@if (this.label != null && this.label.trim() !== '') {
<label class="control-label" [class.obrigatorio]="this.required">
  {{ this.label }}
</label>
}
<div class="via-lazy-select-container">
  <ng-select class="form-control ng-select-searchable ng-select-clearable ng-select ng-select-single ng-untouched ng-pristine"
             [clearable]="this.clearable"
             [items]="this.items"
             [placeholder]="this.placeholder"
             [bindValue]="this.bindValue"
             [bindLabel]="this.bindLabel"
             [formControl]="this.customFormControl"
             [loading]="this.loading"
             [readonly]="this.readonly"
             [loadingText]="this.loadingText"
             [virtualScroll]="this.virtualScroll"
             [bindLabel]="this.bindLabel"
             [bindValue]="this.bindValue"
             [clearAllText]="this.clearAllText"
             [searchable]="this.searchable"
             [title]="this.customFormControl.value?.lazyLabel ?? ''"
             [dropdownPosition]="this.dropdownPosition"
             [notFoundText]="this.notFoundText"
             [required]="this.required"
             (open)="this.onOpen()">
    @if (this.lazyLabelFunction != null) {
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <span [ngOptionHighlight]="search" [title]="item.lazyLabel">{{ item.lazyLabel }}</span>
    </ng-template>
    }
  </ng-select>
</div>
<suite-rfb-local-messages [control]="this.customFormControl"></suite-rfb-local-messages>